import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Loader } from 'semantic-ui-react';
import _ from 'underscore';
import { Link } from 'react-router-dom';
import Moment from 'moment';

class SysadminHrclaimsViewPage extends Component {
    render() {
        const {hrclaimId} = this.props.match.params;
        const selectedHrclaimData = _.find(this.props.hrclaims, (claim) => claim._id === hrclaimId);
        if (!selectedHrclaimData) { return <Loader active />; }
        const {
            admissionDate,
            amount,
            attachment,
            claimantId,
            claimantName,
            companyId,
            companyName,
            created,
            currency,
            dischargeDate,
            prePostHospitalisation,
            providerName,
            receiptNo,
            typeOfClaim,
            userName,
            visitDate,
            updated,
        } = selectedHrclaimData;
        return (
            <Table celled fixed>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell colSpan={4}>
                            General Claim Information
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>
                            Client
                        </Table.Cell>
                        <Table.Cell>
                            {companyName}
                        </Table.Cell>
                        <Table.Cell>
                            Submitted By
                        </Table.Cell>
                        <Table.Cell>
                            {userName}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>
                            Type Of Claim
                        </Table.Cell>
                        <Table.Cell>
                            {typeOfClaim}
                        </Table.Cell>
                        <Table.Cell>
                            Employee Name
                        </Table.Cell>
                        <Table.Cell>
                            {claimantName}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>
                            Provider
                        </Table.Cell>
                        <Table.Cell>
                            {providerName}
                        </Table.Cell>
                        <Table.Cell>
                            Amount
                        </Table.Cell>
                        <Table.Cell>
                            {currency} {amount}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan={4}>
                            Specific Claim Information
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>
                            Admission Date
                        </Table.Cell>
                        <Table.Cell>
                            {admissionDate}
                        </Table.Cell>
                        <Table.Cell>
                            Discharge Date
                        </Table.Cell>
                        <Table.Cell>
                            {dischargeDate}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>
                            Pre/Post Hospitalisation
                        </Table.Cell>
                        <Table.Cell>
                            {prePostHospitalisation}
                        </Table.Cell>
                        <Table.Cell>
                            visitDate
                        </Table.Cell>
                        <Table.Cell>
                            {visitDate}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>
                            Receipt No
                        </Table.Cell>
                        <Table.Cell>
                            {receiptNo}
                        </Table.Cell>
                        <Table.Cell>
                        </Table.Cell>
                        <Table.Cell>
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>
                            Created
                        </Table.Cell>
                        <Table.Cell>
                            {created}
                        </Table.Cell>
                        <Table.Cell>
                            Updated
                        </Table.Cell>
                        <Table.Cell>
                            {updated}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan={4}>
                            Documents / Attachments
                        </Table.Cell>
                    </Table.Row>
                    {
                        _.map(attachment, (document, index) => {
                            return (
                                <Table.Row key={index}>
                                    <Table.Cell colSpan={4}>
                                        <a href={document.viewUrl} target="_blank">
                                            {document.viewUrl}
                                        </a>
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })
                    }
                </Table.Body>
            </Table>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        clients: state.systemAdmin.clients,
        hrclaims: state.systemAdmin.hrclaims,
    };
}

export default connect(mapStateToProps)(SysadminHrclaimsViewPage);